<a class="skip-link" href="#main-content">Skip to main content</a>

<div class="site-shell">
  <!-- Stage chrome — the dark stage scene every page sits on. data-scene="stage"
       re-binds the role tokens (glow text, cobalt-lit links, amber decor) for
       this region; groove-scene.css paints its bg + fg. site-chrome--extends is
       set when the routed page hosts the stage extension (home's hero), which
       drops the chrome's wave-clearance so the hero continues the stage flush. -->
  <header
    class="site-chrome"
    data-scene="stage"
    [class.site-chrome--extends]="stageExtension()"
  >
    <div class="chrome-nav-row">
      <button
        type="button"
        class="chrome-hamburger groove-ring"
        aria-label="Open navigation"
        aria-controls="mobile-nav-drawer"
        [attr.aria-expanded]="drawerOpen()"
        (click)="openMobileDrawer()"
      >
        <span class="chrome-hamburger-icon" aria-hidden="true"></span>
      </button>
      <app-header />
      <app-top-nav />
      @if (!suppressHeaderCta()) {
        <app-header-cta />
      }
    </div>
  </header>

  <!-- Chrome → paper handoff: the single wavy edge that lets every inner page
       open as stage chrome → torn paper edge → paper content. Placed AFTER the
       stage scene close, in paper (root) scope, so .groove-handoff's
       color: var(--groove-color-bg-page) resolves to the PAPER bg the wave
       fills (see groove-scene.css / standards/scenes.md). Suppressed when the
       route extends the stage itself (home) — that page renders its own. -->
  @if (!stageExtension()) {
    <div class="groove-handoff" aria-hidden="true">
      <svg viewBox="0 0 1440 110" preserveAspectRatio="none">
        <path
          fill="currentColor"
          d="M0,110 L0,70 C240,30 480,95 720,60 C960,25 1200,80 1440,45 L1440,110 Z"
        />
      </svg>
    </div>
  }

  <div class="shell-body" [class.shell-body--bleed]="stageExtension()">
    <div class="shell-main">
      <main
        id="main-content"
        class="content"
        [class.content--article]="measure() === 'article'"
      >
        <app-page-heading />
        @if (breadcrumbs().length > 0 && !stageExtension()) {
          <app-breadcrumb-trail [items]="breadcrumbs()" />
        }
        <router-outlet />
        @if (!suppressFooterCta()) {
          <div class="page-footer-cta">
            <app-page-explore />
            <app-page-cta location="bottom" />
          </div>
        }
      </main>
    </div>
  </div>

  <footer class="site-footer" data-scene="stage">
    <app-footer />
  </footer>
</div>

<app-mobile-drawer
  #mobileDrawer
  id="mobile-nav-drawer"
  (drawerClosed)="drawerOpen.set(false)"
/>

@if (showInDevFeatures && grooveCandidate.enabled()) {
  <app-groove-candidate-switcher />
}
